export enum SettingValueType {
  string = 0,
  boolean = 1,
  number = 2
}
